import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Select from "react-select";
import urls from "../../Utils/urls";
import { LoadingButton } from "../../Utils/CustomComponent";
import axios from "../../axios";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import DragAndDrop from "../../components/Tools/Helper-Components/DragAndDrop";
import FormBox from "../../components/FormBox/FormBox";
const defaultValues = {
  deliveryMethord: "Emailed Report",
  repeat: false,
};
const CreateNewReport = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
  });
  const userId = localStorage.getItem("apex_userid");
  const reportDetailsInfoForScheduledReports = JSON.parse(
    localStorage.getItem("reportDetailsInfoForScheduledReports")
  );
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);

  const reportCategories = [
    { label: "- None -", value: "none" },
    { label: "Portfolio", value: "portfolio" },
    { label: "Revenue", value: "revenue" },
    {
      label: "Remittance / Distribution / Payment Deposit",
      value: "remittance_distribution_payment_deposit",
    },
    {
      label: "Skim (Interest Distribution)",
      value: "skim_interest_distribution",
    },
    { label: "Funding", value: "funding" },
    { label: "Financial", value: "financial" },
    { label: "Trust Ledger", value: "trust_ledger" },
    {
      label: "Property and/or Insurance Monitoring",
      value: "property_insurance_monitoring",
    },
    { label: "Escrow / Impound / Tax", value: "escrow_impound_tax" },
    {
      label: "Trust Balance (Impound, Reserve)",
      value: "trust_balance_impound_reserve",
    },
    { label: "Borrower Payments", value: "borrower_payments" },
    { label: "Charges", value: "charges" },
    { label: "Maturity", value: "maturity" },
    { label: "Loan Management", value: "loan_management" },
    { label: "Delinquency / Late", value: "delinquency_late" },
  ];

  const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
    .value;
  const reportCategory = watch("reportCategory");
  const columnNames = watch("columnNames");
  const onSubmit = async (data) => {
    setLoading(true);
    const id = toast.loading("Schedule Report Pending");
    try {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      };
      await axios.post(
        urls.reportsNDocuments.postScheduleReport(),
        {
          user_id: userId,
          user_role: userRole,
          report_type: "SCHEDULED",
          is_active: "Y",
          report_details: data,
          parameterDetails: reportDetailsInfoForScheduledReports,
        },
        headers
      );
      // localStorage.removeItem('reportDetailsInfoForScheduledReports');
      setLoading(false);
      toast.update(id, {
        render: "Schedule Report Sucess",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    }
  };

  useEffect(() => {
    register("reportFormat", { required: true });
    register("deliveryMethord", { required: true });
  }, [register]);
  const handleChange = (e) => setValue("reportFormat", e.target.value);

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Reports & Documents", link: "/reports-and-documents" },
            { title: "Create New Report", link: "" },
          ]}
        />
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h4>Report Request</h4>
            <hr />
            <p>
              Use this form to let us know the type of report that you are
              looking for us to create. Please include as much descriptive
              information as possible. Screenshots, sample reports, or
              spreadsheets can be very helpful. <br />
              This will create a conversation around what we will custom build
              for your data needs.
            </p>
          </div>
          <section className="bg-white p-5 my-2 mx-4">
            <Form>
              <Form.Group controlId="formBasicEmail" className="row">
                <div className="col-sm-4">
                  <div className="mb-5">
                    <div
                      className={
                        errors.reportName
                          ? "text-error border-error col"
                          : "col"
                      }
                    >
                      <Form.Label className="mt-5">
                        {"Report Name *"}
                      </Form.Label>
                      <Form.Control
                        {...register("reportName", { required: true })}
                        type={"text"}
                        placeholder=""
                        className={
                          errors.reportName ? "text-error border-error" : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="mb-5">
                    <Form.Label
                      className={
                        errors.reportCategory ? "text-error border-error" : ""
                      }
                    >
                      Report Category
                    </Form.Label>
                    <Select
                      name="reportCategory"
                      options={reportCategories}
                      value={reportCategory ? reportCategory : null}
                      // onChange={handleChange}
                      onChange={(selected) => {
                        setValue("reportFormat", selected.value);
                        setValue("reportCategory", selected);
                      }}
                      className={
                        errors.reportCategory ? "text-error border-error" : ""
                      }
                      classNamePrefix="select"
                    />
                  </div>
                  <div className="mb-5">
                    <Form.Label
                      className={
                        errors.reportCategory ? "text-error border-error" : ""
                      }
                    >
                      Column Names
                    </Form.Label>
                    {/* <Select
                      name="columnNames"
                      options={[{ label: "CSV", value: "CSV" }]}
                      value={columnNames ? columnNames : null}
                      onChange={handleChange}
                      className={
                        errors.columnNames ? "text-error border-error" : ""
                      }
                      classNamePrefix="select"
                    /> */}
                    <FormBox
                      options={columnNamesArr}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="mb-5">
                    <div
                      className={
                        errors.reportName
                          ? "text-error border-error col"
                          : "col"
                      }
                    >
                      <Form.Label className="mt-5">
                        {"Report Usage and Description"}
                      </Form.Label>
                      <Form.Control
                        {...register("reportName", { required: true })}
                        as="textarea"
                        type={"text"}
                        rows="3"
                        placeholder=""
                        className={
                          errors.reportName ? "text-error border-error" : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="mb-5">
                    <DragAndDrop files={file} setFiles={setFile} />
                  </div>
                </div>
              </Form.Group>
            </Form>
            <LoadingButton
              className="mt-5 me-5"
              onClick={handleSubmit(onSubmit)}
              title={"Save"}
              loading={loading}
            />
          </section>
        </article>
      </section>
    </div>
  );
};

export default CreateNewReport;

const columnNamesArr = [
  {
    title: "Due Date",
    field: "dueDate",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Interest Amount",
    field: "InterestAmount",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Interest Rate",
    field: "InterestRate",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Lender Account Number",
    field: "LenderAccountNumber",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Loan Account Number",
    field: "LoanAccountNumber",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Next Due Date",
    field: "NextDueDate",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Payment Received Date",
    field: "PaymentReceivedDate",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Principal Amount",
    field: "PrincipalAmount",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Principal Balance",
    field: "PrincipalBalance",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Property Address",
    field: "PropertyAddress",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Property City",
    field: "PropertyCity",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Property State",
    field: "PropertyState",
    type: "checkbox",
    className: "col-6",
  },
  {
    title: "Property Zip Code",
    field: "PropertyZipCode",
    type: "checkbox",
    className: "col-6",
  },
];
